module.exports = __webpack_public_path__ + "img/subLogo.14866a9b.png";